import {useReducer} from 'react'

const INITIAL_STATE = {
  isLogged: false,
  isAuthenticationVerified: false,
  isConcluded: false,
  googleAccessToken: ''
}

const ACTIONS = {
  SET_IS_LOGGED: 'SET_IS_LOGGED',
  SET_IS_AUTHENTICATION_VERIFIED: 'SET_IS_AUTHENTICATION_VERIFIED',
  SET_IS_CONCLUDED: 'SET_IS_CONCLUDED',
  SET_GOOGLE_ACCESS_TOKEN: 'SET_GOOGLE_ACCESS_TOKEN'
}

const reducer = (state, action) => {
  const {type, payload} = action
  switch (type) {
    case ACTIONS.SET_IS_LOGGED:
    case ACTIONS.SET_IS_AUTHENTICATION_VERIFIED:
    case ACTIONS.SET_IS_CONCLUDED:
    case ACTIONS.SET_GOOGLE_ACCESS_TOKEN:
      return {
        ...state,
        ...payload
      }
    default:
      return state
  }
}

const useComponentState = () => {
  const [state, dispatch] = useReducer(reducer, INITIAL_STATE)

  const setIsLogged = isLogged => {
    dispatch({
      type: ACTIONS.SET_IS_LOGGED,
      payload: {isLogged}
    })

    dispatch({
      type: ACTIONS.SET_IS_AUTHENTICATION_VERIFIED,
      payload: {isAuthenticationVerified: true}
    })
  }

  const setIsConcluded = () => {
    dispatch({
      type: ACTIONS.SET_IS_CONCLUDED,
      payload: {isConcluded: true}
    })
  }

  const setGoogleAccessToken = googleAccessToken => {
    dispatch({
      type: ACTIONS.SET_GOOGLE_ACCESS_TOKEN,
      payload: {googleAccessToken}
    })
  }

  return [
    state,
    {
      setIsLogged,
      setIsConcluded,
      setGoogleAccessToken
    }
  ]
}

export default useComponentState
